var env;
try {
    env = process.env.TARO_ENV;
    var docEnv = process.env.DOC_ENV;
    if (docEnv === "h5") {
        env = null;
    }
}
catch (_) {
    // ignore
}
export var TaroEnv = env;
//# sourceMappingURL=env.js.map